<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4 group">
          <h4>{{$t('shared.contact')}}</h4>
          <ul>
            <li>
              <i class="fa fa-envelope"></i>
              <a class="email" href="mailto:hello@fontanelabs.de">
                <span class="text-muted">E-Mail</span>
              </a>
            </li>
            <li>
              <i class="fab fa-linkedin"></i>
              <a href="https://www.linkedin.com/company/fontanelabs/" target="_blank">
                <span class="text-muted">LinkedIn</span>
              </a>
            </li>
            <li>
              <i class="fab fa-facebook"></i>
              <a href="https://www.facebook.com/fontanelabs/" target="_blank">
                <span class="text-muted">Facebook</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="col-12 col-md-4 group">
          <h4>{{$t('shared.links')}}</h4>
          <ul>
            <li>
              <router-link to="/">
                <span class="text-muted">
                  {{$t('shared.home')}}
                </span>
              </router-link>
            </li>
            <li>
              <router-link to="/imprint">
                <span class="text-muted">
                  {{$t('shared.imprint')}}
                </span>
              </router-link>
            </li>
            <li>
              <router-link to="/privacy-policy">
                <span class="text-muted">
                  {{$t('shared.privacy-policy')}}
                </span>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="col-12 group">
          <span>
            &copy; 2018 Fontane Labs
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<i18n src='@/assets/locales/shared.json'></i18n>
<i18n>

</i18n>

<script>
export default {
  name: 'Footer',
  data() {
    return {

    };
  },
};
</script>

<style scoped lang="scss">
footer {
  min-height: 42px;
  height: auto;
  padding: 2rem 2rem 0;
  background-color: #343a40;
  z-index: 5;

  .group {
    color: #6c757d;
    padding-bottom: 20px;

    ul {
      list-style-type: none;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue